<template>
  <div>
    <div class="full-overlay" :class="{hidden: loaded}">
      <div>
        <i class="fas fa-circle-notch fa-spin fa-5x"></i>
      </div>
    </div>
    <div class="container custom-template-edit">
      <div class="alert alert-danger" role="alert" v-if="error">
        {{error.message}}
      </div>
      <div class="main-wrapper">
        <div class="save-wrapper">
          <div class="action back"><div @click="goBack()"><i class="fas fa-chevron-left"></i> Back</div></div>
          <div class="action next">
            <button class="btn btn-primary btn-sm" @click="saveAs()" :disabled="saving">Next</button>
          </div>
        </div>

        <div class="template-wrapper">
          <div class="canvas invisible" :style="{ backgroundImage: getFilterCss({ color1: template.filterColor1, color2: template.filterColor2, alpha: template.filterAlpha }, this.canvasImageUrl) }">
            <div class="quotebox" :style="{fontFamily: getFontName(template.fontFaceQuote), lineHeight: getFontLineSpacing(template.fontFaceQuote)}">
              <p :style="{ color: template.fontColorQuote, backgroundColor: quoteBackgroundCss, borderRadius: `${backgroundRadiusQuote}px`, padding: getQuoteBackgroundPadding() }">{{quote}}</p>
            </div>
            <div class="authorbox" :style="{fontFamily: getFontName(template.fontFaceAuthor)}"><p :style="{ color: template.fontColorAuthor }">{{author}}</p></div>
            <div class="watermarkbox" :style="{backgroundColor: watermarkBackgroundCss}" v-show="!removeWatermark"><p class="justify-center" :style="{ color: template.watermarkColor, fontFamily: getFontName(watermarkFont) }">{{watermarkText}}</p></div>
          </div>
        </div>
        <!--<div class="attribution-selected" v-if="template.attributionName">
          Image by <a :href="template.attributionUrl" target="_blank">{{template.attributionName}}</a> on <a :href="template.attributionProviderUrl" target="_blank" class="text-capitalize">{{template.attributionProvider}}</a>
        </div>-->
      <div class="tools-wrapper small-scroll">

        <template>

          <div class="accordion w-100" role="tablist">

            <!-- Background -->
            <div class="card accordion-background">
              <div v-b-toggle.accordion-background class="card-header p-0">
                <button class="d-flex px-4 align-items-center justify-content-between btn btn-link btn-accordion">
                  <div class="heading d-flex align-items-center">
                    <h3 class="mb-0"><span>Background</span></h3>
                  </div>
                  <div class="icon d-flex align-items-center justify-content-center">
                    <i class="fas fa-chevron-down"></i>
                  </div>
                </button>
              </div>
              <b-collapse id="accordion-background" accordion="my-accordion" role="tabpanel" @shown="openTab('background')" @hide="closeTab('background')">
                <div class="card-body p-3 small-scroll">

                  <div class="input-group mb-3">
                    <input type="text" class="form-control" placeholder="Search for something..." v-model="query" v-on:keyup.enter="search(query)" v-on:focus="$event.target.select()">
                    <div class="input-group-append" @click="search(query)">
                      <span class="input-group-text"><i class="fas fa-search fa-flip-horizontal pointer"></i></span>
                    </div>
                  </div>

                  <div class="card mb-2">
                    <div class="card-body">
                      <div class="tool-label">Search Ideas</div>
                      <p class="card-text text-center">
                        <template v-for="searchIdea in searchIdeas">
                          <span class="badge badge-primary pointer mr-1" @click="search(searchIdea)">{{searchIdea}}</span>
                        </template>
                      </p>
                    </div>
                  </div>

                  <div class="tool-row">
                    <div class="tool-item">
                      <template>
                        <div>
                          <b-form-checkbox v-model="removeQuoteBackground" name="check-removeQuoteBackground" switch>
                            Remove the text background
                          </b-form-checkbox>
                        </div>
                      </template>
                    </div>
                  </div>

                  <transition name="slide">
                    <div class="tool-row" v-show="!removeQuoteBackground">
                      <div class="tool-item">
                        <div class="tool-label">Text Background Color</div>
                        <input type="color" class="quote-background-color-picker" :value="template.backgroundColorQuote" />
                      </div>
                      <div class="tool-item">
                        <div class="tool-label">Intensity</div>
                        <input type="range" class="custom-range" v-model="template.backgroundAlphaQuote" id="backgroundAlphaQuote" min="0" max="255" @input="setQuoteBackgroundCss(removeQuoteBackground, false)">
                      </div>
                    </div>
                  </transition>

                  <div class="card mt-2" v-if="recentImages.length">
                    <div class="card-header">
                      <div class="section-header">
                        <div class="section-header-title">
                          <span>Recently Viewed</span>
                        </div>
                        <div class="section-header-action"><span class="badge badge-pill badge-secondary pointer" @click="clearRecentImages()">Clear</span></div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="d-flex flex-wrap justify-content-center">
                        <template v-for="(image, index) in recentImages">
                          <div class="image-search-preview recent" @click="selectImage(image)" :class="template.shape" :style="{ backgroundImage: getPreviewFilterCss({ color1: template.filterColor1, color2: template.filterColor2, alpha: template.filterAlpha }, image.imageUrlPreview) }"></div>
                        </template>
                      </div>
                    </div>
                  </div>

                </div>
              </b-collapse>
            </div>

            <!-- Filters -->
            <div class="card accordion-filter">
              <div v-b-toggle.accordion-filter class="card-header p-0">
                <button class="d-flex px-4 align-items-center justify-content-between btn btn-link btn-accordion">
                  <div class="heading d-flex align-items-center">
                    <h3 class="mb-0"><span>Filter</span></h3>
                  </div>
                  <div class="icon d-flex align-items-center justify-content-center">
                    <i class="fas fa-chevron-down"></i>
                  </div>
                </button>
              </div>
              <b-collapse id="accordion-filter" accordion="my-accordion" role="tabpanel" @shown="openTab('filter')" @hide="closeTab('filter')">
                <div class="card-body p-3">

                  <transition name="slide">
                    <div class="tool-row" key="filterAlpha" v-show="template.filterName">
                      <div class="tool-item">
                        <div class="tool-label">Filter Intensity</div>
                        <input type="range" class="custom-range" v-model="template.filterAlpha" id="filterAlpha" min="0" max="255">
                      </div>
                    </div>
                  </transition>

                  <div class="filter-grid">
                    <div class="mb-2 filter-grid-item">
                      <div class="filter-preview" :style="{ backgroundImage: `url('${canvasImageUrl}')` }" @click="setFilter()"></div>
                      <span class="tool-label text-center" :class="{'selected-item': !template.filterName}">No Filter</span>
                    </div>
                    <template v-for="(filter, index) in filters.data">
                      <div class="mb-2 filter-grid-item">
                        <div class="filter-preview" :style="{ backgroundImage: getFilterCss(filter, canvasImageUrl) }" @click="setFilter(filter.filterId)"></div>
                        <span class="tool-label text-center" :class="{'selected-item': template.filterName == filter.name}">{{filter.name}}</span>
                      </div>
                    </template>
                  </div>

                </div>
              </b-collapse>
            </div>

            <!-- Font Quote -->
            <div class="card accordion-quote">
              <div v-b-toggle.accordion-quote class="card-header p-0">
                <button class="d-flex px-4 align-items-center justify-content-between btn btn-link btn-accordion">
                  <div class="heading d-flex align-items-center">
                    <h3 class="mb-0"><span>Quote</span></h3>
                  </div>
                  <div class="icon d-flex align-items-center justify-content-center">
                    <i class="fas fa-chevron-down"></i>
                  </div>
                </button>
              </div>
              <b-collapse id="accordion-quote" accordion="my-accordion" role="tabpanel" @shown="openTab('quote')" @hide="closeTab('quote')">
                <div class="card-body">

                  <div class="tool-row">
                    <div class="tool-item">
                      <div class="tool-label">Color</div>
                      <input type="color" class="quote-color-picker" :value="template.fontColorQuote" />
                    </div>
                    <div class="tool-item">
                      <div class="tool-label">Alignment</div>
                      <span class="tool-button">
                        <i class="fas fa-align-left alignment-option" @click="setQuoteJustification('left')" :class="{'selected-item': template.textAlignQuote == 0}"></i>
                        <i class="fas fa-align-center alignment-option" @click="setQuoteJustification('center')" :class="{'selected-item': template.textAlignQuote == 1}"></i>
                        <i class="fas fa-align-right alignment-option" @click="setQuoteJustification('right')" :class="{'selected-item': template.textAlignQuote == 2}"></i>
                      </span>
                    </div>
                  </div>

                  <div class="tool-row">
                    <div class="tool-item">
                      <div class="tool-label">Font</div>
                      <span class="tool-button" :style="{fontFamily: getFontName(template.fontFaceQuote)}" @click="openFontSidebar('quote')">{{getFontName(template.fontFaceQuote)}} <i class="fas fa-edit pl-5"></i></span>
                    </div>
                  </div>

                  <div class="tool-row">
                    <div class="tool-item">
                      <div class="tool-label">Quote</div>
                      <div>
                        <textarea style="width: 100%; height: 100px;" v-model="quote" @input="scaleFont('quotebox')"></textarea>
                      </div>
                    </div>
                  </div>

                </div>
              </b-collapse>
            </div>

            <!-- Font Author -->
            <div class="card accordion-author">
              <div v-b-toggle.accordion-author class="card-header p-0">
                <button class="d-flex px-4 align-items-center justify-content-between btn btn-link btn-accordion">
                  <div class="heading d-flex align-items-center">
                    <h3 class="mb-0"><span>Author</span></h3>
                  </div>
                  <div class="icon d-flex align-items-center justify-content-center">
                    <i class="fas fa-chevron-down"></i>
                  </div>
                </button>
              </div>
              <b-collapse id="accordion-author" accordion="my-accordion" role="tabpanel" @shown="openTab('author')" @hide="closeTab('author')">
                <div class="card-body p-3">

                  <div class="tool-row">
                    <div class="tool-item">
                      <template>
                        <div>
                          <b-form-checkbox v-model="fontSameAsQuote" name="check-fontSameAsQuote" switch @change="copyFontSettings()">
                            Same style as quote
                          </b-form-checkbox>
                        </div>
                      </template>
                    </div>
                  </div>

                  <transition name="slide">
                    <div v-show="!fontSameAsQuote">
                      <div class="tool-row">
                        <div class="tool-item">
                          <div class="tool-label">Color</div>
                          <input type="color" class="author-color-picker" :value="template.fontColorAuthor" />
                        </div>
                        <div class="tool-item">
                          <div class="tool-label">Alignment</div>
                          <span class="tool-button">
                            <i class="fas fa-align-left alignment-option" @click="setAuthorJustification('left')" :class="{'selected-item': template.textAlignAuthor == 0}"></i>
                            <i class="fas fa-align-center alignment-option" @click="setAuthorJustification('center')" :class="{'selected-item': template.textAlignAuthor == 1}"></i>
                            <i class="fas fa-align-right alignment-option" @click="setAuthorJustification('right')" :class="{'selected-item': template.textAlignAuthor == 2}"></i>
                          </span>
                        </div>
                      </div>

                      <div class="tool-row">
                        <div class="tool-item">
                          <div class="tool-label">Font</div>
                          <span class="tool-button" :style="{fontFamily: getFontName(template.fontFaceAuthor)}" @click="openFontSidebar('author')">{{getFontName(template.fontFaceAuthor)}} <i class="fas fa-edit pl-5"></i></span>
                        </div>
                      </div>
                    </div>
                  </transition>

                  <div class="tool-row">
                    <div class="tool-item">
                      <div class="tool-label">Author</div>
                      <div>
                        <input type="text" style="width: 100%" v-model="author" @input="scaleFont('authorbox')" />
                      </div>
                    </div>
                  </div>

                </div>
              </b-collapse>
            </div>

            <!-- Shapes -->
            <div class="card accordion-shape">
              <div v-b-toggle.accordion-shape class="card-header p-0">
                <button class="d-flex px-4 align-items-center justify-content-between btn btn-link btn-accordion">
                  <div class="heading d-flex align-items-center">
                    <h3 class="mb-0"><span>Shape</span></h3>
                  </div>
                  <div class="icon d-flex align-items-center justify-content-center">
                    <i class="fas fa-chevron-down"></i>
                  </div>
                </button>
              </div>
              <b-collapse id="accordion-shape" accordion="my-accordion" role="tabpanel" @shown="openTab('shape')" @hide="closeTab('shape')">
                <div class="card-body p-3">

                  <div class="tool-row">
                    <div class="tool-item justify-center">
                      <div class="tool-label" :class="{'selected-item': template.shape == 'natural'}">Original</div>
                      <span class="tool-button" @click="setShape('natural')"><img src="/images/natural.png" /></span>
                    </div>
                    <div class="tool-item justify-center">
                      <div class="tool-label" :class="{'selected-item': template.shape == 'landscape'}">Landscape</div>
                      <span class="tool-button" @click="setShape('landscape')"><img src="/images/landscape.png" /></span>
                    </div>
                    <div class="tool-item justify-center">
                      <div class="tool-label" :class="{'selected-item': template.shape == 'portrait'}">Portrait</div>
                      <span class="tool-button" @click="setShape('portrait')"><img src="/images/portrait.png" /></span>
                    </div>
                    <div class="tool-item justify-center">
                      <div class="tool-label" :class="{'selected-item': template.shape == 'square'}">Square</div>
                      <span class="tool-button" @click="setShape('square')"><img src="/images/square.png" /></span>
                    </div>
                  </div>

                </div>
              </b-collapse>
            </div>

            <!-- Watermark -->
            <div class="card accordion-watermark">
              <div v-b-toggle.accordion-watermark class="card-header p-0">
                <button class="d-flex px-4 align-items-center justify-content-between btn btn-link btn-accordion">
                  <div class="heading d-flex align-items-center">
                    <h3 class="mb-0"><span>Watermark</span></h3>
                  </div>
                  <div class="icon d-flex align-items-center justify-content-center">
                    <i class="fas fa-chevron-down"></i>
                  </div>
                </button>
              </div>
              <b-collapse id="accordion-watermark" accordion="my-accordion" role="tabpanel" @shown="openTab('watermark')" @hide="closeTab('watermark')">
                <div class="card-body p-3">

                  <div class="tool-row">
                    <div class="tool-item">
                      <template>
                        <div>
                          <b-form-checkbox v-model="removeWatermark" name="check-removeWatermark" switch>
                            Remove the watermark
                          </b-form-checkbox>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div class="mb-3">
                    <transition name="slide">
                      <div class="pb-2" v-if="removeWatermark">
                        <small class="text-danger"><span class="badge badge-danger">NOTE</span> Watermarks won't be displayed on quotes made with this design, even if you have enabled watermarks in your account settings.</small>
                      </div>
                    </transition>
                    <div>
                      <small class="text-muted">You can update your watermark font and text in <nuxt-link to="/user/settings#watermark" target="_blank">Account Settings</nuxt-link></small>
                    </div>
                  </div>

                  <transition name="slide">
                    <div v-show="!removeWatermark">
                      <div class="tool-row">
                        <div class="tool-item">
                          <div class="tool-label">Font Color</div>
                          <input type="color" class="watermark-color-picker" :value="template.watermarkColor" :disabled="removeWatermark" />
                        </div>
                        <div class="tool-item">
                          <div class="tool-label">Background Color</div>
                          <input type="color" class="watermark-background-color-picker" :value="template.watermarkBackgroundColor" :disabled="removeWatermark" />
                        </div>
                      </div>

                      <div class="tool-row mt-2">
                        <div class="tool-item">
                          <div class="tool-label">Intensity</div>
                          <input type="range" class="custom-range" v-model="template.watermarkAlpha" id="watermarkAlpha" min="0" max="255" :disabled="removeWatermark" @input="setWatermarkCss(removeWatermark, false)">
                        </div>
                      </div>
                    </div>
                  </transition>

                </div>
              </b-collapse>
            </div>

            <!-- Advanced -->
            <div class="card accordion-advanced">
              <div v-b-toggle.accordion-advanced class="card-header p-0">
                <button class="d-flex px-4 align-items-center justify-content-between btn btn-link btn-accordion">
                  <div class="heading d-flex align-items-center">
                    <h3 class="mb-0"><span>Advanced</span></h3>
                  </div>
                  <div class="icon d-flex align-items-center justify-content-center">
                    <i class="fas fa-chevron-down"></i>
                  </div>
                </button>
              </div>
              <b-collapse id="accordion-advanced" accordion="my-accordion" role="tabpanel" @shown="openTab('advanced')" @hide="closeTab('advanced')">
                <div class="card-body p-3">
                  <div class="tool-row" v-if="self.isAdmin">
                    <div class="tool-item">
                      <template>
                        <div>
                          <b-form-checkbox v-model="template.asPersonal" name="check-asPersonal" switch v-if="add">
                            Publish to my personal account
                          </b-form-checkbox>
                          <b-form-checkbox v-model="template.active" name="check-active" switch v-if="!template.asPersonal">
                            Make active
                          </b-form-checkbox>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div class="tool-row">
                    <div class="tool-item">
                      <div class="tool-label">Undo Changes</div>
                      <div>
                        <small class="text-muted" v-if="add">This will undo changes you have made, and will reload the default design.</small>
                        <small class="text-muted" v-if="!add">This will undo the changes you have made since the last time you saved this template.</small>
                      </div>
                      <div>
                        <span class="btn btn-warning" @click="resetTemplate()"><i class="fas fa-undo"></i> Undo Changes</span>
                      </div>
                    </div>
                  </div>

                  <div class="tool-row" v-if="!add">
                    <div class="tool-item">
                      <div class="tool-label">Delete Design</div>
                      <div>
                        <small class="text-muted">This will remove this design from your account, but will not change quotes you previously made with this design.</small>
                      </div>
                      <div>
                        <button class="btn btn-danger" v-b-modal.modal-confirm-delete title="Delete"><i class="fas fa-trash-alt"></i> Delete Design</button>
                      </div>
                    </div>
                  </div>

                </div>
              </b-collapse>
            </div>

          </div>

        </template>

        <template>
          <b-sidebar v-model="showFontSidebar" id="sidebar-fonts" ref="fontSidebar" title="Choose Your Font" shadow body-class="small-scroll">

            <template v-slot:header>
              <div class="section-header">
                <div class="section-header-title">
                  <span>Choose Your Font</span>
                </div>
                <div class="section-header-action"><i class="fas fa-times pointer" @click="closeFontSidebar()"></i></div>
              </div>
            </template>

            <div v-for="font in fonts" :key="font.file" @click="selectFont(font)">
              <span :style="{fontFamily: font.name}" class="font-preview">{{font.name}} <img class="is-pro-icon" style="position: unset; margin-left: 5px;" v-if="font.isPro && !self.isPro" src="/images/pro.png"></span>
            </div>
          </b-sidebar>
        </template>

        <template>
          <b-sidebar v-model="showImageSearchSidebar" id="sidebar-images" ref="imageSearchSidebar" title="Choose Your Background" body-class="small-scroll image-search-scroll" shadow>

            <template v-slot:header>
              <div class="section-header">
                <div class="section-header-title">
                  <template v-if="searchResults && searchResults.data && searchResults.data.length">
                    <a class="attribution-provider" :href="searchResults.data[0].providerUrl" target="_blank">Image Search by <span class="text-capitalize">{{searchResults.data[0].provider}}</span></a>
                  </template>
                </div>
                <div class="section-header-action"><i class="fas fa-times pointer" @click="closeImageSearchSidebar()"></i></div>
              </div>
              <div class="section-header">
                <div class="section-header-title">
                  <b-form-checkbox v-model="previewImageWithFilter" name="check-previewImageWithFilter" v-if="template.filterName" switch>
                    <span>Preview filter</span>
                  </b-form-checkbox>
                </div>
              </div>
            </template>

            <div class="d-flex flex-wrap justify-content-center" v-if="imageSearchMessage">
              <div>{{imageSearchMessage}}</div>
            </div>

            <div class="d-flex flex-wrap justify-content-center">
              <template v-for="(image, index) in searchResults.data">
                <div class="image-search-preview" @click="selectImage(image, true)" :class="template.shape" :style="{ backgroundImage: getPreviewFilterCss({ color1: template.filterColor1, color2: template.filterColor2, alpha: template.filterAlpha }, image.imageUrlPreview), position: 'relative' }">
                  <a :href="image.attributionUrl" target="_blank"><div class="attribution">{{image.attributionName}}</div></a>
                  <img class="is-pro-icon shadow" v-if="image.isPro && !self.isPro" src="/images/pro.png">
                </div>
              </template>
            </div>
          </b-sidebar>
        </template>
        <b-modal id="save-as" title="Save Design" hide-footer>
          <p class="text-center"><i class="far fa-save fa-5x text-primary"></i></p>
          <p class="my-4">
            <h5 class="text-center">How do you want to save this design?</h5>
          </p>
          <hr />
          <p class="my-4 text-center">
            <button class="btn btn-success" @click="saveTemplate(false)" :disabled="saving">Update Existing Design</button>
            <div class="text-center">
              <small class="text-muted">
                When you update your existing design, you will change your existing design, and these changes will be applied to existing quotes you've created with this design.
              </small>
            </div>
          </p>
          <hr />
          <p class="my-4 text-center">
            <button class="btn btn-success" @click="saveTemplate(true)" :disabled="saving">Save As New Design</button>
            <div class="text-center">
              <small class="text-muted">
                When you save as a new design, you will create a new design that can be used separately from your current design.
              </small>
            </div>
          </p>
        </b-modal>
        <b-modal id="modal-get-quozio-pro-images" title="Get Quozio Pro" hide-footer>
          <p class="text-center"><i class="fas fa-images fa-8x text-primary"></i></p>
          <p class="my-4">
            <h5 class="text-center">Want access to millions of additional images?</h5>
          </p>
          <p class="my-4 text-center">
            Get Quozio Pro for millions more images, extra fonts, premium pre-made templates, custom watermarks, full-size downloads, and more!
          </p>
          <p class="my-4 text-center">
            <router-link class="btn btn-success btn-lg" :to="{ name: 'get-quozio-pro', query: { ref: 'SELPI' } }">Learn More</router-link>
          </p>
        </b-modal>
        <b-modal id="modal-get-quozio-pro-fonts" title="Get Quozio Pro" hide-footer>
          <p class="text-center"><i class="fas fa-palette fa-8x text-primary"></i></p>
          <p class="my-4">
            <h5 class="text-center">Want access to the full font collection?</h5>
          </p>
          <p class="my-4 text-center">
            Get Quozio Pro for more fonts, millions more images, premium pre-made templates, custom watermarks, full-size downloads, and more!
          </p>
          <p class="my-4 text-center">
            <router-link class="btn btn-success btn-lg" :to="{ name: 'get-quozio-pro', query: { ref: 'SELPF' } }">Learn More</router-link>
          </p>
        </b-modal>
        <b-modal id="modal-get-quozio-pro" title="Get Quozio Pro" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close>
          <p class="text-center"><i class="fas fa-palette fa-8x text-primary"></i></p>
          <p class="my-4">
            <h5 class="text-center">Looking to create your own custom quote designs?</h5>
          </p>
          <p class="my-4 text-center">
            Get Quozio Pro to create custom designs, fonts, millions of images, premium pre-made templates, custom watermarks, full-size downloads, and more!
          </p>
          <p class="my-4 text-center">
            <router-link class="btn btn-success btn-lg" :to="{ name: 'get-quozio-pro', query: { ref: 'CUSTDES' } }">Learn More</router-link>
          </p>
          <p class="my-4 text-center">
            Already Pro? <router-link :to="{ name: 'sign-in', query: { redirect: getRoutePath() } }" v-cloak>Sign In</router-link>.
          </p>
        </b-modal>
        <b-modal id="modal-create-account-save-design" title="Save Design" hide-footer>
          <p class="text-center"><i class="fas fa-palette fa-5x text-primary"></i></p>
          <p class="my-4">
            <h5 class="text-center">Want to save this design?</h5>
          </p>
          <p class="my-4 text-center">
            No problem! Create a free Quozio account to save your custom designs. Don't worry, we'll save your work as you sign up.
          </p>
          <p class="my-4 text-center">
            <router-link class="btn btn-success btn-lg" :to="{ name: 'join', query: { redirect: getRoutePath() } }">Join Now, It's Free!</router-link>
          </p>
          <p class="my-4 text-center">
            Already have an account? <router-link :to="{ name: 'sign-in', query: { redirect: getRoutePath() } }" v-cloak>Sign In</router-link>.
          </p>
        </b-modal>
        <b-modal id="modal-confirm-delete" title="Delete Design">
          <p class="text-center"><i class="fas fa-exclamation-triangle fa-5x text-warning"></i></p>
          <p class="my-4">
            Are you sure you want to delete this design?
          </p>
          <p>
            <small class="text-muted">
              If you proceed, you will not be able to create new quotes with this design. However, quotes you previously created in the past will not be changed or deleted.
            </small>
          </p>
          <template v-slot:modal-footer="{ ok, cancel, hide }">
            <div class="flex-grow-1">
              <button class="btn btn-sm btn-danger" @click="deleteItem()" :disabled="submitting.deleteItem"><i class="fas fa-trash-alt"></i> Yes, Delete</button>
            </div>
            <div>
              <button class="btn btn-primary btn-sm" @click="cancel()">Cancel</button>
            </div>
          </template>
        </b-modal>
      </div>
      </div>
    </div>
  </div>
</template>
<style>
  .full-overlay {
    opacity: 0.75;
    background: #ffffff;
    width: 100%;
    height: 100%;
    z-index: 10;
    top: 0;
    left: 0;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .save-wrapper {
    height: 40px;
    border-bottom: 1px solid #eee;
    display: grid;
    grid-template-columns: 1fr 100px;
    grid-template-rows: 1fr;
    background-color: #f0f0f0;
  }

    .save-wrapper .action {
      display: flex;
      flex-wrap: wrap;
      align-content: center;
      padding: 0 5px 0 5px;
    }

      .save-wrapper .action.back {
        justify-content: left;
        color: #007bff;
        font-size: 12px;
        cursor: pointer;
      }

      .save-wrapper .action.next {
        justify-content: right;
      }

  .hidden {
    display: none;
  }

  .container.custom-template-edit {
    padding: 0;
  }

  .disabled {
    cursor: not-allowed;
    opacity: 0.25;
  }

  .main-wrapper {
    height: 100vh;
  }

  .tools-wrapper {
    /* This is the exact height needed to prevent a scrollbar when all tool items are collapsed. */
    /* If you change the height, you must also change the height of image-search-sidebar height for mobile. */
    height: 302px;
    overflow-y: auto;
  }

  .canvas {
    z-index: 1;
    position: relative;
    margin: 0 auto;
    background-position: center;
    background-size: cover;
  }

  .quotebox, .authorbox, .watermarkbox {
    position: absolute;
    box-sizing: border-box;
    background-color: rgba(196, 196, 196, 0.4);
    cursor: move;
    display: flex;
    align-items: center;
  }

  .quotebox, .authorbox, .watermarkbox {
    position: absolute;
    box-sizing: border-box;
    cursor: move;
    display: flex;
    align-items: center;
  }

  .quotebox, .authorbox {
    background-color: rgba(196, 196, 196, 0.4);
  }

    .quotebox > p, .authorbox > p, .watermarkbox > p {
      margin: 0;
      width: 100%;
      color: white;
    }

  .quotebox {
    z-index: 3;
    min-height: 100px;
    min-width: 100px;
  }

  .authorbox {
    z-index: 4;
    max-height: 75px;
    min-height: 10px;
    min-width: 100px;
  }

  .watermarkbox {
    z-index: 2;
    max-height: 50px;
    min-height: 15px;
    min-width: 100%;
  }

  .invisible {
    opacity: 0;
  }

  .hide-guides:not(.watermarkbox) {
    background-color: transparent !important;
  }

  .moveable-origin {
    display: none !important; /* Makes sure the middle dot never shows. Even though it's configured to be off, it flashes on transitions unless we also hide it here. */
  }

  .moveable-line {
    display: none !important; /* Makes sure the border lines never show. Even though they are configured to be off, it flashes on transitions unless we also hide it here. */
  }

  .justify-left {
    text-align: left !important;
  }

  .justify-center {
    text-align: center !important;
  }

  .justify-right {
    text-align: right !important;
  }

  .tool-row {
    display: flex;
    padding-bottom: 9px;
  }

  .tool-item {
    flex: 1;
    margin-bottom: 7px;
  }

  .tool-label {
    text-transform: uppercase;
    font-size: 11px;
    font-weight: bold;
    padding-bottom: 2px;
  }

  .alignment-option {
    padding-left: 10px;
    padding-right: 10px;
  }

  .font-preview {
    font-size: 22px;
    margin: 20px;
    cursor: pointer;
  }

  .tool-button {
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    color: #616161;
    border: 1px solid #ccc;
    padding: 7px;
    border-radius: 7px;
    cursor: pointer;
    background: linear-gradient(#ffffff, #ededed);
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }

    .tool-button img {
      width: 50px;
    }

  .selected-item {
    color: #5c91f2;
  }

  .filter-grid {
    display: grid;
    column-gap: 5px;
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (min-width: 576px) {
    .filter-grid {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }

  @media (min-width: 992px) {
    .filter-grid {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
  }

  .filter-grid-item {
    text-align: center;
  }

  .filter-preview {
    margin: auto;
    width: 100px;
    height: 100px;
    background-position: center;
    background-size: cover;
    cursor: pointer;
  }

  .slide-enter-active {
    transition-duration: 0.3s;
    transition-timing-function: linear;
  }

  .slide-leave-active {
    transition-duration: 0.3s;
    transition-timing-function: linear;
  }

  .slide-enter-to, .slide-leave {
    max-height: 150px;
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
  }

  .accordion-header {
    background-color: #f5f5f5;
    color: #878787;
    font-size: 16px;
    border: 1px solid #c7c7c7;
    margin: 5px;
    padding: 10px;
    border-radius: 5px;
  }

  .btn-accordion {
    padding-left: 10px !important;
    width: 100%;
    padding: 0;
    font-size: 18px;
    border-radius: 0 !important;
    border: none;
    background: #f0f0f0;
    border-bottom: 3px solid rgba(255, 255, 255, 0.1);
  }

  .accordion.card,
  .accordion.card:last-child .card-header {
    border: none;
    border-radius: 0 !important;
  }

  .accordion .btn-accordion h3, .accordion .btn-accordion .icon i {
    color: #828282;
  }

    .accordion .btn-accordion h3 span {
      display: block;
      font-size: 14px;
      text-transform: uppercase;
    }

  .accordion .btn-accordion .icon i {
    font-size: 20px;
  }

  .accordion .btn-link:hover,
  .accordion .btn-link:focus {
    text-decoration: none;
  }

  .card-header button {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }

  .card-body {
    background: #f5f5f5;
    padding: 12px;
  }

  .b-sidebar-header {
    display: block !important;
  }

  .section-header {
    display: grid;
    grid-template-columns: 1fr 75px;
    grid-template-rows: 1fr;
  }

  .section-header-title {
    font-size: 18px;
    display: flex;
    align-items: center;
  }

  .section-header-action {
    text-align: right;
  }

  #sidebar-images, #sidebar-fonts {
    top: unset;
    bottom: 0;
    width: 100%;
    height: 307px; /* Must be the same as the toolbox-wrapper */
  }

  .attribution-selected {
    padding: 3px;
    margin: 3px;
    font-size: 12px;
    text-align: right;
  }

  .attribution-provider {
    color: #000;
  }

  .custom-template-edit .attribution {
    font-size: 10px;
    background: rgba(0, 0, 0, .25);
    padding: 2px;
    color: #fff;
    display: none;
  }

  .image-search-preview:hover .attribution {
    display: block !important;
  }

  .image-search-preview {
    cursor: pointer;
    margin: 5px;
    background-position: center;
  }

    .image-search-preview.square.recent, .image-search-preview.natural.recent {
      width: 78px;
      height: 75px;
      background-size: cover;
    }

    .image-search-preview.landscape.recent {
      width: 139px;
      height: 78px;
      background-size: cover;
    }

    .image-search-preview.portrait.recent {
      width: 78px;
      height: 139px;
      background-size: cover;
    }

    .image-search-preview.square, .image-search-preview.natural {
      width: 103px;
      height: 103px;
      background-size: cover;
    }

    .image-search-preview.landscape {
      width: 160px;
      height: 90px;
      background-size: cover;
    }

    .image-search-preview.portrait {
      width: 103px;
      height: 183px;
      background-size: cover;
    }

  @media (min-width: 576px) {
    .image-search-preview.square, .image-search-preview.natural {
      width: 125px;
      height: 125px;
    }

    .image-search-preview.landscape {
      width: 170px;
      height: 96px;
    }

    .image-search-preview.portrait {
      width: 96px;
      height: 170px;
    }
  }

  @media (min-width: 992px) {
    .image-search-preview.square, .image-search-preview.natural {
      width: 155px;
      height: 155px;
    }

    .image-search-preview.landscape {
      width: 163px;
      height: 92px;
    }

    .image-search-preview.portrait {
      width: 118px;
      height: 210px;
    }
  }

  @media (min-width: 1400px) {
    .image-search-preview.portrait {
      width: 160px;
      height: 284px;
    }

    #sidebar-images, #sidebar-fonts {
      top: 0;
      width: 350px;
      height: 100vh;
    }
  }

  @media (min-width: 1800px) {
    #sidebar-images, #sidebar-fonts {
      width: 550px;
    }

    .image-search-preview.portrait {
      width: 170px;
      height: 302px;
    }

    .image-search-preview.landscape {
      width: 260px;
      height: 146px;
    }
  }
</style>
<script>
  import { mapState, mapActions } from "vuex";
  import Moveable from 'moveable';

  // Define your classes for your quote and author divs.
  let quoteboxClass = "quotebox";
  let authorboxClass = "authorbox";
  let watermarkboxClass = "watermarkbox";
  let canvasClass = "canvas";

  // Some helpers
  let directionMap = { left: 0, center: 1, right: 2 };
  let colorPickerDelay = 100;
  export default {
    data() {
      return {
        quote: null,
        author: null,
        fontSameAsQuote: true,
        showFontSidebar: false,
        showImageSearchSidebar: false,
        sidebarFontType: null,
        quoteMoveable: null,
        authorMoveable: null,
        watermarkMoveable: null,
        add: true,
        query: null,
        searchResults: { data: [] },
        template: {
          active: true,
          fixedTextPosition: {
          },
        },
        savedFixedTextPositions: {
          natural: null,
          landscape: null,
          portrait: null,
          square: null,
        },
        backgroundRadiusQuote: 0,
        savedFilterSettings: {},
        canvasImageUrl: null,
        previewImageWithFilter: false,
        currentOpenTab: null,
        backgroundLoadReady: true,
        recentImages: [],
        imageSearchMessage: null,
        quoteColorPickerTimeout: null,
        quoteBackgroundColorPickerTimeout: null,
        authorColorPickerTimeout: null,
        watermarkColorPickerTimeout: null,
        watermarkFont: null,
        watermarkText: null,
        removeWatermark: false,
        removeQuoteBackground: false,
        watermarkBackgroundCss: null,
        quoteBackgroundCss: null,
        searchIdeas: ["texture", "sunset", "paper", "background", "light", "gradient", "canvas", "pattern", "nature", "scenery"],
        submitting: { deleteItem: false },
        loaded: false,
        saving: false,
        error: null,
        filters: [],
        fonts: [],
      };
    },
    head() {
      let families = "";
      this.fonts.forEach(font => {
        families += `&family=${font.name.replace(" ", "+")}`;
      })
      return {
        title: "Edit Design - Quozio",
        link: [
          {
            rel: "stylesheet",
            href: `https://fonts.googleapis.com/css2?display=swap${families}`,
          },
        ],
        meta: [
          { hid: 'viewport', name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no' }
        ],
      }
    },
    async asyncData({ store, app, params, error, query }) {

      var self = await store.dispatch("self/get", app.$cookies);

      // Get the fonts
      let fontResponse = await app.$dataService.get("/fonts?active=true");
      if (fontResponse.error) {
        return error({ statusCode: fontResponse.error.status, message: fontResponse.error.message, reference: fontResponse.error.reference });
      }
      let fonts = fontResponse.data.data;

      // Get the filters.
      let filterResponse = await app.$dataService.get("/filters?desc=true&active=true");
      if (filterResponse.error) {
        return error({ statusCode: filterResponse.error.status, message: filterResponse.error.message, reference: filterResponse.error.reference });
      }
      let filters = filterResponse.data;

      let templateId = params.templateId || "default";
      let templateResponse = await app.$dataService.get(`/userTemplates/${templateId}`);
      if (templateResponse.error) {
        return error({ statusCode: templateResponse.error.status, message: templateResponse.error.message, reference: templateResponse.error.reference });
      }
      let template = templateResponse.data;

      // Set some defaults defaults.
      let canvasImageUrl = template.canvasMiddleUrl + "?preview=true";
      let add = true;

      if (!params.templateId) {

        // By default, this should be set to true, regardless of what the default template says.
        template.active = true;

      } else {

        // Indicate that this is an existing template, not new.
        add = false;

        // If the template has a font that is not active, set to the first font.
        let defaultFont = fonts.find(item => item.isPro === false);
        if (fonts.find(item => item.file === template.fontFaceQuote) == null) {
          template.fontFaceQuote = defaultFont.file;
        }

        if (fonts.find(item => item.file === template.fontFaceAuthor) == null) {
          template.fontFaceAuthor = defaultFont.file;
        }

        // The template might have a filter that no longer exists, is custom, or has been modified. We want to include it in our list of templates, so the user can continue to interact with it.
        let templateFilter = {
          name: template.filterName,
          color1: template.filterColor1,
          color2: template.filterColor2,
          alpha: template.filterAlpha,
          fontColorQuote: template.fontColorQuote,
          fontColorAuthor: template.fontColorAuthor,
          filterId: "templateFilter",
        }

        // If the filter on the template is the same name as a filter in the list, replace the filter in the list with the filter on the template.
        // This will prevent two versions of the same template from appearing in the list.
        filters.data = filters.data.filter(function (filter) {
          return filter.name !== templateFilter.name;
        });

        // Now, add their template, if any, to the list as the first item.
        if (template.filterName && template.filterColor1) {
          filters.data.unshift(templateFilter);
        }
      }

      let removeQuoteBackground = false;
      if (!template.backgroundColorQuote || !template.backgroundAlphaQuote) {
        // Hide it, but set some default values if they turn it on.
        removeQuoteBackground = true;
        template.backgroundColorQuote = "#ffffff";
        template.backgroundAlphaQuote = 175;
        template.backgroundRadiusQuote = 35;
      }

      let removeWatermark = false;
      if (!template.watermarkBackgroundColor || !template.watermarkBackgroundHeight) {
        // Hide it, but set some default values if they turn it on.
        removeWatermark = true;
        template.watermarkColor = "#ffffff";
        template.watermarkBackgroundColor = "#000000";
        template.watermarkBackgroundHeight = 90;
        template.watermarkAlpha = 80;
      }

      // If the user is not Pro, hide the watermark. It won't show up on the template they save anyway, so we aren't going to show it.
      if (!self.isPro) {
        removeWatermark = true;
      }

      // Get the watermark settings from the user's account, or just use defaults if not signed in.
      let watermarkText = "Your Watermark Here";
      let watermarkFont = "Poppins.ttf";
      let settingsResponse = await app.$dataService.get("/users/me", { expand: "settings" });
      if (!settingsResponse.error) {
        watermarkText = settingsResponse.data.settings.watermarkText || watermarkText;
        watermarkFont = settingsResponse.data.settings.watermarkFont;
      }

      watermarkFont = (fonts.find(i => i.file == watermarkFont) || fonts[0]).file;
      let quote = "Success is to be measured not so much by the position that one has reached in life as by the obstacles which he has overcome while trying to succeed.";
      let author = "Booker T. Washington";

      // If a quoteId is passed into the query string, use it as the quote contents.
      if (query.quoteId) {
        let quoteResponse = await app.$dataService.get(`/quotes/${query.quoteId}`);
        if (!quoteResponse.error) {
          quote = quoteResponse.data.quote;
          author = quoteResponse.data.author;
        }
      }

      // If an admin, mark as "asPersonal" by default
      if (self.isAdmin) {
        template.asPersonal = true
      }

      return { template: template, canvasImageUrl: canvasImageUrl, quote: quote, author: author, add: add, filters: filters, watermarkText: watermarkText, watermarkFont: watermarkFont, fonts: fonts, removeQuoteBackground: removeQuoteBackground, removeWatermark: removeWatermark };
    },
    async mounted() {

      // If the user is not pro, show the Get Quozio Pro dialog
      if (!this.self?.isPro) {
        this.$bvModal.show("modal-get-quozio-pro");
        this.$ga.event("GetQuozioPro", "Get Quozio Pro - Custom Template Image Modal");
      }

      // Set the height of the area the image will be previewed. This is the basis for the rest of the sizes.
      this.setTemplateWrapperHeight();

      // If there's saved state for this template, get it now. This prevents someone from losing their work due to au unexpected browser reload.
      this.loadCurrentState();

      // When navigating to this page from another location in the app (i.e. not full refresh of page), the initial canvas measurements are incorrect because the fonts have not finished rendering.
      // As such, when you run the scaleFont function, it gives incorrect measurements for some large fonts (such as Cinzel) because it is measuring with a default font rather than a stylized font.
      // I tried all sorts of things to address it, but the only thing that seemed to work is delay bootstrapping things for a half second to give the font a chance to render.
      // It'll actually do it sooner than 500ms (on my machine at least) but I am uncertain with lower CPU devices, such as mobiles, so I extended it. I really don't love this. There are probably better options.
      setTimeout(async () => {

        // Load the background image, then the canvas.
        let backgroundImage = await this.loadImage(this.canvasImageUrl);

        // Set the default coordinates
        let coordinates = this.getDefaultCoordinates(backgroundImage);

        // If this is an existing template, use the server's saved settings for the coordinates.
        if (!this.add) {
          coordinates = this.mapCoordinates(backgroundImage, this.template.serverCanvasWidth, this.template.serverCanvasHeight, this.template.fixedTextPosition, this.template.watermarkBackgroundHeight)
        }

        // If we have local saved coordinates for this shape, use those coordinates instead.
        let savedCoordinates = this.savedFixedTextPositions[this.template.shape];
        if (savedCoordinates) {
          coordinates = this.mapCoordinates(backgroundImage, savedCoordinates.canvasWidth, savedCoordinates.canvasHeight, savedCoordinates.fixedTextPosition, savedCoordinates.watermarkHeight);
        }

        // Render the canvas
        this.loadCanvas(coordinates, backgroundImage, true);

        // On initial load, we'll need to convert backgroundRadiusQuote to a client value, based on the scale factor.
        let canvasHeight = document.querySelector(`.${canvasClass}`).offsetHeight;
        let scaleFactor = this.getScaleFactor(this.template.serverCanvasWidth, this.template.serverCanvasHeight, this.template.shape, canvasHeight);
        this.backgroundRadiusQuote = this.template.backgroundRadiusQuote * scaleFactor;

        // Set the CSS for the quote background and watermark
        this.setQuoteBackgroundCss(this.removeQuoteBackground, true);
        this.setWatermarkCss(this.removeWatermark, true);

        // Save the current position so if the user chooses other shapes and come back to this one, they will get the same settings.
        this.saveFixedTextPositions();

      }, 500);

    },
    beforeDestroy() {
      // Remove event listeners
      this.unlistenForQuoteColorPickerInput();
      this.unlistenForQuoteBackgroundColorPickerInput();
      this.unlistenForAuthorColorPickerInput();
      this.unlistenForWatermarkColorPickerInput();
      this.unlistenForWatermarkBackgroundColorPickerInput();
      this.unlistenForClickOffCanvas();
    },
    watch: {
      removeQuoteBackground(newValue) {
        this.setQuoteBackgroundCss(newValue, true);
        this.saveCurrentState();
      },
      removeWatermark(newValue) {
        this.setWatermarkCss(newValue, true);
        this.saveCurrentState();
      },
      template: {
        handler() {
          this.saveCurrentState();
        },
        deep: true
      }
    },
    methods: {
      loadImage(url) {
        return new Promise((resolve, reject) => {
          let img = new Image();
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.id = "template-background";
          img.src = url;
        });
      },
      setTemplateWrapperHeight() {
        // Set the height of the canvas, based on the height of the main wrapper and tools wrapper.
        // This will keep the tools in a consistent location at the bottom of the page, regardless of the height of the image.
        let mainWrapper = document.querySelector(".main-wrapper");
        let toolsWrapper = document.querySelector(".tools-wrapper");
        let saveWrapper = document.querySelector(".save-wrapper");
        let templateWrapper = document.querySelector(".template-wrapper");
        templateWrapper.style.height = `${mainWrapper.offsetHeight - saveWrapper.offsetHeight - toolsWrapper.offsetHeight - 1}px`; // Subtract 1 to prevent a scrollbar on the main page.
      },
      loadCanvas(coordinates, image, flashGuides) {

        // Determine how tall you can make the image.
        let canvas = document.querySelector(`.${canvasClass}`);
        let templateWrapper = document.querySelector(".template-wrapper");

        // Calculate the size of the canvas, depending on the selected aspect ratio.
        let canvasSize = this.getCanvasSize(this.template.shape, image, templateWrapper.offsetWidth, templateWrapper.offsetHeight);

        // Now, set the canvas to the actual size of the image.
        canvas.style.width = `${canvasSize.width}px`;
        canvas.style.height = `${canvasSize.height}px`;

        // Check if the author font settings are the same as the quote font settings.
        if ((this.template.fontFaceAuthor.toLowerCase() != this.template.fontFaceQuote.toLowerCase()) || (this.template.fontColorAuthor.toLowerCase() != this.template.fontColorQuote.toLowerCase()) || (this.template.textAlignAuthor != this.template.textAlignQuote)) {
          this.fontSameAsQuote = false;
        }

        // Now, set the justification of the text.
        this.setQuoteJustification(this.getJustificationName(this.template.textAlignQuote));
        this.setAuthorJustification(this.getJustificationName(this.template.textAlignAuthor));

        // If moveables already exist on the canvas, destroy them.
        if (this.quoteMoveable) {
          this.quoteMoveable.destroy();
        }
        if (this.authorMoveable) {
          this.authorMoveable.destroy();
        }
        if (this.watermarkMoveable) {
          this.watermarkMoveable.destroy();
        }

        // Create your moveables with your inputs.
        this.quoteMoveable = this.createMoveable(quoteboxClass, canvasClass, { x: coordinates.fixedTextPosition.quoteX, y: coordinates.fixedTextPosition.quoteY, width: coordinates.fixedTextPosition.quoteWidth, height: coordinates.fixedTextPosition.quoteHeight }, 5, true);
        this.authorMoveable = this.createMoveable(authorboxClass, canvasClass, { x: coordinates.fixedTextPosition.authorX, y: coordinates.fixedTextPosition.authorY, width: coordinates.fixedTextPosition.authorWidth, height: coordinates.fixedTextPosition.authorHeight }, 5, true);
        this.watermarkMoveable = this.createMoveable(watermarkboxClass, canvasClass, { x: coordinates.watermarkX, y: coordinates.watermarkY, width: coordinates.watermarkWidth, height: coordinates.watermarkHeight }, 0, false);

        // Hide the guides by default, flash them if instructed.
        this.hideGuides(this.quoteMoveable, quoteboxClass);
        this.hideGuides(this.authorMoveable, authorboxClass);
        this.hideGuides(this.watermarkMoveable, watermarkboxClass);
        if (flashGuides) {
          this.flashGuides();
        }

        // Add your event listners to show / hide the guides when the user clicks on or off the moveables.
        this.listenForClickOffCanvas();

        // Set the default color picker values.
        document.querySelector(".quote-color-picker").value = this.template.fontColorQuote;
        document.querySelector(".author-color-picker").value = this.template.fontColorAuthor;
        document.querySelector(".watermark-color-picker").value = this.template.watermarkColor;
        document.querySelector(".watermark-background-color-picker").value = this.template.watermarkBackgroundColor;

        // Add event listners to the color pickers.
        // If you try to do this with a simple vue model, the performance is horrible when the user drags around selecting colors.
        this.listenForQuoteColorPickerInput();
        this.listenForQuoteBackgroundColorPickerInput();
        this.listenForAuthorColorPickerInput();
        this.listenForWatermarkColorPickerInput();
        this.listenForWatermarkBackgroundColorPickerInput();
        canvas.classList.remove("invisible");
        this.loaded = true;
      },
      async reloadCanvas() {
        this.setTemplateWrapperHeight();
        let backgroundImage = await this.loadImage(this.canvasImageUrl);

        // Do we have something saved for this shape?
        let savedCoordinates = this.savedFixedTextPositions[this.template.shape];
        if (savedCoordinates) {
          // Convert the saved coordinates to the appropriate coordinates for the current canvas size.
          savedCoordinates = this.mapCoordinates(backgroundImage, savedCoordinates.canvasWidth, savedCoordinates.canvasHeight, savedCoordinates.fixedTextPosition, savedCoordinates.watermarkHeight);
        }

        // If you don't have anything, get the default coordinates.
        savedCoordinates = savedCoordinates || this.getDefaultCoordinates(backgroundImage);
        this.loadCanvas(savedCoordinates, backgroundImage);
        this.saveFixedTextPositions();
      },
      getCanvasSize(shape, image, maxWidth, maxHeight) {
        // Calculate the size of the canvas, depending on the selected aspect ratio.
        let width, height, aspect;
        switch (shape) {
          case "landscape":
            // 16:9 aspect ratio
            aspect = 16 / 9;
            width = Math.min(maxWidth, maxHeight * aspect);
            height = Math.min(maxHeight, maxWidth / aspect);
            break;
          case "portrait":
            // 9:16 aspect ratio
            aspect = 9 / 16;
            width = Math.min(maxWidth, maxHeight * aspect);
            height = Math.min(maxHeight, maxWidth / aspect);
            break;
          case "square":
            // 1:1 aspect ratio.
            aspect = 1 / 1;
            width = Math.min(maxWidth, maxHeight * aspect);
            height = Math.min(maxHeight, maxWidth / aspect);
            break;
          default:
            // Natural aspect ratio, best fit.
            const bestRatio = Math.min(maxWidth / image.naturalWidth, maxHeight / image.naturalHeight);
            width = image.naturalWidth * bestRatio;
            height = image.naturalHeight * bestRatio;
        }
        return { width: width, height: height };
      },
      mapCoordinates(image, basisCanvasWidth, basisCanvasHeight, basisFixedTextPosition, basisWatermarkBackgroundHeight) {
        let templateWrapper = document.querySelector(".template-wrapper");
        let canvasSize = this.getCanvasSize(this.template.shape, image, templateWrapper.offsetWidth, templateWrapper.offsetHeight);
        let scaleFactor = this.getScaleFactor(basisCanvasWidth, basisCanvasHeight, this.template.shape, canvasSize.height);
        let result = {
          fixedTextPosition: {
            authorHeight: basisFixedTextPosition.authorHeight * scaleFactor,
            authorWidth: basisFixedTextPosition.authorWidth * scaleFactor,
            authorX: basisFixedTextPosition.authorX * scaleFactor,
            authorY: basisFixedTextPosition.authorY * scaleFactor,
            quoteHeight: basisFixedTextPosition.quoteHeight * scaleFactor,
            quoteWidth: basisFixedTextPosition.quoteWidth * scaleFactor,
            quoteX: basisFixedTextPosition.quoteX * scaleFactor,
            quoteY: basisFixedTextPosition.quoteY * scaleFactor,
          },
          watermarkHeight: basisWatermarkBackgroundHeight * scaleFactor,
          watermarkWidth: canvasSize.width,
          watermarkX: 0,
          watermarkY: canvasSize.height - basisWatermarkBackgroundHeight * scaleFactor,
          canvasWidth: canvasSize.width,
          canvasHeight: canvasSize.height,
        };
        return result;
      },
      getDefaultCoordinates(image) {
        let margin = 10; // The margin from the edges and between quote and author
        let authorHeight = 20; // The height of the author box
        let watermarkHeight = 15; // The height of the watermark box
        // Define our media queries.
        let sm = window.matchMedia("(min-width: 576px)").matches;
        let md = window.matchMedia("(min-width: 768px)").matches;
        let lg = window.matchMedia("(min-width: 992px)").matches;
        let xl = window.matchMedia("(min-width: 1200px)").matches;
        const sizes = {
          sm: { margin: 10, authorHeight: 20, watermarkHeight: 20 },
          md: { margin: 15, authorHeight: 25, watermarkHeight: 25 },
          lg: { margin: 25, authorHeight: 30, watermarkHeight: 30 },
          xl: { margin: 25, authorHeight: 30, watermarkHeight: 30 }, // Same as lg.
        };
        const size = xl ? "xl" : lg ? "lg" : md ? "md" : sm ? "sm" : null;
        if (size) {
          margin = sizes[size].margin;
          authorHeight = sizes[size].authorHeight;
          watermarkHeight = sizes[size].watermarkHeight;
        }
        let templateWrapper = document.querySelector(".template-wrapper");
        let canvasSize = this.getCanvasSize(this.template.shape, image, templateWrapper.offsetWidth, templateWrapper.offsetHeight);
        let x = margin;
        let quoteY = margin;
        let watermarkX = 0;
        let watermarkWidth = canvasSize.width;
        let watermarkY = canvasSize.height - watermarkHeight;
        // Now, establish your author height and y
        let authorY = canvasSize.height - watermarkHeight - authorHeight - (margin * 2);
        // And finally, calculate your quote height
        let quoteHeight = authorY - (margin * 2);
        let result = {
          fixedTextPosition: {
            authorHeight: authorHeight,
            authorWidth: canvasSize.width - (margin * 2),
            authorX: x,
            authorY: authorY,
            quoteHeight: quoteHeight,
            quoteWidth: canvasSize.width - (margin * 2),
            quoteX: x,
            quoteY: quoteY,
          },
          watermarkHeight: watermarkHeight,
          watermarkWidth: watermarkWidth,
          watermarkX: watermarkX,
          watermarkY: watermarkY,
          canvasWidth: canvasSize.width,
          canvasHeight: canvasSize.height,
        };
        return result;
      },
      scaleFont(targetClass) {
        const min = 4; // in px
        let max = 80;
        if (targetClass == authorboxClass) {
          max = 50;
        }
        let target = document.querySelector(`.${targetClass}`);
        let content = document.querySelector(`.${targetClass} > p`);
        content.style.fontSize = `${max}px`;
        // Starting at the max, work your way down until the height of the content is less than the height of the target.
        for (var i = max; i >= min; i -= 1) {
          if (content.offsetHeight >= target.offsetHeight) {
            content.style.fontSize = `${i}px`;
            continue;
          }
          return;
        }
      },
      showGuides(moveable, targetClass) {
        let box = document.querySelector(`.${targetClass}`);
        if (targetClass == watermarkboxClass) {
          if (!this.removeWatermark) {
            moveable.renderDirections = ["n", "nw", "ne"];
          }
        } else {
          moveable.renderDirections = ["n", "nw", "ne", "s", "se", "sw", "e", "w"];
        }
        box.classList.remove("hide-guides");
      },
      hideGuides(moveable, targetClass) {
        let box = document.querySelector(`.${targetClass}`);
        moveable.renderDirections = [];
        box.classList.add("hide-guides");
      },
      flashGuides() {
        let times = 2, timer = 1250, count = 0;
        let repeat = () => {
          if (count < times) {
            this.showGuides(this.quoteMoveable, quoteboxClass);
            this.showGuides(this.authorMoveable, authorboxClass);
            this.showGuides(this.watermarkMoveable, watermarkboxClass);
            setTimeout(() => {
              this.hideGuides(this.quoteMoveable, quoteboxClass);
              this.hideGuides(this.authorMoveable, authorboxClass);
              this.hideGuides(this.watermarkMoveable, watermarkboxClass);
            }, 750);
            count++;
            setTimeout(repeat, timer);
          }
        }
        repeat();
      },
      createMoveable(targetClass, containerClass, coordinates, edgeMargin, draggable) {
        let container = document.querySelector(`.${containerClass}`);
        let target = document.querySelector(`.${targetClass}`);
        let content = document.querySelector(`.${targetClass} > p`);
        // Set the coordinates
        target.style.width = `${coordinates.width}px`;
        target.style.height = `${coordinates.height}px`;
        target.style.left = `${coordinates.x}px`;
        target.style.top = `${coordinates.y}px`;
        // Reset any transforms that may be applied to the style to the default.
        target.style.transform = "translate(0px, 0px)";
        const moveable = new Moveable(container, {
          target: target,
          draggable: draggable,
          zoom: 1,
          padding: { "left": 0, "top": 0, "right": 0, "bottom": 0 },
          resizable: true,
          snappable: true,
          snapDirections: { "middle": true, "center": true },
          verticalGuidelines: [(container.offsetWidth / 2)],
          horizontalGuidelines: [(container.offsetHeight / 2)],
          renderDirections: [], // Turn the blue anchors off by default
        });
        moveable.pinchable = false;
        moveable.origin = false; // Hides the center dot.
        moveable.hideDefaultLines = false; // Hides box outline
        moveable.bounds = { left: edgeMargin, right: container.offsetWidth - edgeMargin, top: edgeMargin, bottom: container.offsetHeight - edgeMargin };
        // Initiate the correct font size.
        this.scaleFont(targetClass);
        // Define the moveable events
        moveable.on("dragEnd", e => {
          // The click / touch event doesn't always register with a click / touch + drag. Show the guides after the drag has stopped.
          this.showGuides(moveable, targetClass);
          // Save the position locally for future reference.
          this.saveFixedTextPositions();
        });
        moveable.on("resizeEnd", e => {
          // Adjust the font size to fit the box.
          this.scaleFont(targetClass);
          // Unhide the content text
          content.classList.remove("invisible");
          // Save the position locally for future reference.
          this.saveFixedTextPositions();
        });
        let frame = {
          translate: [0, 0],
        };
        moveable.on("drag", e => {
          frame.translate = e.beforeTranslate;
        }).on("resize", e => {
          // Hide the content text, which is ugly and distracting when the box is being resized.
          content.classList.add("invisible");
          const beforeTranslate = e.drag.beforeTranslate;
          frame.translate = beforeTranslate;
          e.target.style.width = `${e.width}px`;
          e.target.style.height = `${e.height}px`;
          e.target.style.transform = `translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px)`;
        }).on("render", e => {
          const { translate } = frame;
          e.target.style.transform = `translate(${translate[0]}px, ${translate[1]}px)`;
        });
        return moveable;
      },
      async selectImage(image, addToHistory) {

        // Check if the user is eligible to use this image
        if (image.isPro && !this.self.isPro) {
          this.$bvModal.show("modal-get-quozio-pro-images");
          this.$ga.event("GetQuozioPro", "Get Quozio Pro - Custom Template Image Modal", image.imageId);
          return;
        }

        this.canvasImageUrl = image.imageUrlMedium;
        this.template.imageUrl = image.imageUrlFull;
        this.template.attributionName = image.attributionName;
        this.template.attributionUrl = image.attributionUrl;
        this.template.attributionCallbackUrl = image.callbackUrl;
        this.template.attributionImageId = image.imageId;
        this.template.attributionProvider = image.provider;
        this.template.attributionProviderUrl = image.providerUrl;
        this.template.attributionIsPro = image.isPro;
        this.template.attributionHash = image.attributionHash;
        if (addToHistory) {
          var existing = this.recentImages.find(img => {
            return img.imageId == image.imageId
          })
          if (!existing) {
            this.recentImages.push(image);
          }
        }
        await this.reloadCanvas();
      },
      clearRecentImages() {
        this.recentImages = [];
        this.saveCurrentState();
      },
      setShape(shape) {
        this.template.shape = shape;
        this.reloadCanvas();
      },
      setQuoteFont(font) {
        this.template.fontFaceQuote = font.file;
        this.setFont(quoteboxClass);
      },
      setAuthorFont(font) {
        this.template.fontFaceAuthor = font.file;
        this.setFont(authorboxClass);
      },
      setFont(targetClass) {
        let element = document.querySelector(`.${targetClass}`);
        element.classList.add("invisible");
        // The new font needs time to render so it can be accurately measured.
        setTimeout(() => {
          this.scaleFont(targetClass);
          element.classList.remove("invisible");
        }, 15);
      },
      setQuoteJustification(direction) {
        let element = document.querySelector(`.${quoteboxClass} > p`);
        this.setJustification(element, direction);
        this.template.textAlignQuote = this.getJustificationNumber(direction);
        if (this.fontSameAsQuote) {
          this.setAuthorJustification(direction);
        }
      },
      setAuthorJustification(direction) {
        let element = document.querySelector(`.${authorboxClass} > p`);
        this.setJustification(element, direction);
        this.template.textAlignAuthor = this.getJustificationNumber(direction);
      },
      setJustification(element, direction) {
        element.classList.remove("justify-left", "justify-center", "justify-right");
        element.classList.add(`justify-${direction}`);
      },
      setFilter(filterId) {
        // Save a snapshot of the current filter settings so you can re-use their settings if they re-select it.
        let newSavedFilter = {
          name: this.template.filterName,
          color1: this.template.filterColor1,
          color2: this.template.filterColor2,
          alpha: this.template.filterAlpha,
          fontColorAuthor: this.template.fontColorAuthor,
          fontColorQuote: this.template.fontColorQuote,
          backgroundColorQuote: this.template.backgroundColorQuote,
        }
        this.savedFilterSettings[newSavedFilter.name || "none"] = newSavedFilter;
        // If you have the selected filter saved, use it.
        let savedFilterName = filterId == null ? "none" : (this.filters.data.find(item => item.filterId == filterId))?.name;
        let savedFilter;
        if (savedFilterName && this.savedFilterSettings[savedFilterName]) {
          savedFilter = this.savedFilterSettings[savedFilterName];
        }
        let filter = savedFilter || this.filters.data.find(item => item.filterId == filterId);
        this.template.filterColor1 = filter?.color1;
        this.template.filterColor2 = filter?.color2;
        this.template.filterAlpha = filter?.alpha;
        this.template.filterName = filter?.name;
        if (filter) {
          this.template.fontColorQuote = filter.fontColorQuote;
          this.template.fontColorAuthor = filter.fontColorAuthor;
          this.template.backgroundColorQuote = filter.backgroundColorQuote;
          this.setQuoteBackgroundCss(this.removeQuoteBackground, true);
        }
        if (!filter) {
          this.previewImageWithFilter = false;
        }
      },
      getFilterCss(filter, imageUrl) {
        if (filter.color1) {
          return `linear-gradient(to bottom, ${this.convertToRgba(filter.color1, filter.alpha)} 0%, ${this.convertToRgba(filter.color2, filter.alpha)} 100%), url('${imageUrl}')`;
        } else {
          return `url('${imageUrl}')`;
        }
      },
      getPreviewFilterCss(filter, imageUrl) {
        if (this.previewImageWithFilter) {
          return this.getFilterCss(filter, imageUrl)
        } else {
          return `url('${imageUrl}')`;
        }
      },
      setQuoteBackgroundCss(removeQuoteBackground, redraw) {
        if (removeQuoteBackground) {
          this.quoteBackgroundCss = "transparent";
        } else {
          this.quoteBackgroundCss = this.convertToRgba(this.template.backgroundColorQuote, this.template.backgroundAlphaQuote);
          if (redraw) {
            // Redraw the text to fit within the newly applied CSS.
            this.setFont(quoteboxClass);
          }
        }
      },
      setWatermarkCss(removeWatermark, redraw) {
        if (removeWatermark) {
          this.watermarkBackgroundCss = "transparent";
        } else {
          this.watermarkBackgroundCss = this.convertToRgba(this.template.watermarkBackgroundColor, this.template.watermarkAlpha);
          if (redraw) {
            // Redraw the text to fit within the newly applied CSS.
            this.setFont(watermarkboxClass);
          }
        }
      },
      getQuoteBackgroundPadding() {
        if (this.removeQuoteBackground || !this.template.backgroundColorQuote || !this.template.backgroundAlphaQuote) {
          return 0;
        } else {
          return "10px";
        }
      },
      convertToRgba(hex, alpha) {
        if (hex) {
          hex = hex.replace(/[^0-9A-F]/gi, '');
          var bigint = parseInt(hex, 16);
          var r = (bigint >> 16) & 255;
          var g = (bigint >> 8) & 255;
          var b = bigint & 255;
          var a = alpha = alpha / 255;
          return `rgba(${r}, ${g}, ${b}, ${a})`;
        }
      },
      getScaleFactor(serverWidth, serverHeight, shape, clientHeight) {
        let croppedSize = this.calculateCroppedSize(serverWidth, serverHeight, shape);
        return clientHeight / croppedSize.height;
      },
      getDefaultFixedTextPosition(shape, clientHeight, clientWidth, serverWidth, serverHeight, serverCoords, serverWatermarkBackgroundHeight) {
        // Set the default values.
        let watermarkHeight = 30;
        let x = margin;
        let quoteY = margin;
        let watermarkX = 0;
        let watermarkWidth = clientWidth;
        let watermarkY = clientHeight - watermarkHeight;
        // Now, establish your author height and y
        let authorY = clientHeight - watermarkHeight - authorHeight - (margin * 2);
        // And finally, calculate your quote height
        let quoteHeight = authorY - (margin * 2);
        let result = {
          authorHeight: authorHeight,
          authorWidth: clientWidth - (margin * 2),
          authorX: x,
          authorY: authorY,
          quoteHeight: quoteHeight,
          quoteWidth: clientWidth - (margin * 2),
          quoteX: x,
          quoteY: quoteY,
          watermarkHeight: watermarkHeight,
          watermarkWidth: watermarkWidth,
          watermarkX: watermarkX,
          watermarkY: watermarkY,
        }
        if (serverCoords) {
          // You'll need to adjust the canvasWidth according to the shape of the image to get the correct scale factor.
          let scaleFactor = this.getScaleFactor(serverWidth, serverHeight, shape, clientHeight);
          result = {
            authorHeight: Math.round(serverCoords.authorHeight * scaleFactor),
            authorWidth: Math.round(serverCoords.authorWidth * scaleFactor),
            authorX: Math.round(serverCoords.authorX * scaleFactor),
            authorY: Math.round(serverCoords.authorY * scaleFactor),
            quoteHeight: Math.round(serverCoords.quoteHeight * scaleFactor),
            quoteWidth: Math.round(serverCoords.quoteWidth * scaleFactor),
            quoteX: Math.round(serverCoords.quoteX * scaleFactor),
            quoteY: Math.round(serverCoords.quoteY * scaleFactor),
            watermarkHeight: serverWatermarkBackgroundHeight * scaleFactor,
            watermarkWidth: result.watermarkWidth,
            watermarkX: result.watermarkX,
          };
          result.watermarkY = Math.round(clientHeight - result.watermarkHeight);
        }
        return result;
      },
      saveFixedTextPositions() {
        let canvas = document.querySelector(`.${canvasClass}`);
        let quoteCoords = this.quoteMoveable.getRect();
        let authorCoords = this.authorMoveable.getRect();
        let watermarkCoords = this.watermarkMoveable.getRect();
        let fixedTextPosition = {
          authorHeight: Math.round(authorCoords.height),
          authorWidth: Math.round(authorCoords.width),
          authorX: Math.round(authorCoords.left),
          authorY: Math.round(authorCoords.top),
          quoteHeight: Math.round(quoteCoords.height),
          quoteWidth: Math.round(quoteCoords.width),
          quoteX: Math.round(quoteCoords.left),
          quoteY: Math.round(quoteCoords.top),
        };
        this.savedFixedTextPositions[this.template.shape] = {
          fixedTextPosition: fixedTextPosition,
          watermarkHeight: Math.round(watermarkCoords.height),
          watermarkWidth: Math.round(watermarkCoords.width),
          watermarkX: Math.round(watermarkCoords.left),
          watermarkY: Math.round(watermarkCoords.top),
          canvasWidth: canvas.offsetWidth,
          canvasHeight: canvas.offsetHeight,
        };
        // Update the template with the current selection.
        this.template.fixedTextPosition = fixedTextPosition;
        this.template.watermarkBackgroundHeight = Math.round(watermarkCoords.height);
        // Record the change in state
        this.saveCurrentState();
      },
      getFontName(fontFile) {
        if (fontFile) {
          return (this.fonts.find(item => item.file === fontFile).name);
        }
      },
      getFontLineSpacing(fontFile) {
        if (fontFile) {
          return (this.fonts.find(item => item.file === fontFile).lineSpacing);
        }
      },
      getJustificationNumber(directionName) {
        return directionMap[directionName];
      },
      getJustificationName(directionNumber) {
        for (const property in directionMap) {
          if (directionMap[property] == directionNumber)
            return property;
        }
      },
      openTab(item) {
        this.currentOpenTab = item;
        const el = document.querySelector(`.accordion-${item}`);
        const pos = el.getBoundingClientRect().top + window.pageYOffset
        el.scrollIntoView({
          behavior: "smooth",
          top: pos,
        })
      },
      closeTab(item) {
        if (this.currentOpenTab == item) {
          this.currentOpenTab = null
        }
        if (item == "quote" || item == "author") {
          this.closeFontSidebar();
        }
      },
      calculateCroppedSize(width, height, shape) {
        let aspect;
        switch (shape) {
          case "landscape":
            // 16:9 aspect ratio
            aspect = 16 / 9;
            width = Math.min(width, height * aspect);
            height = Math.min(height, width / aspect);
            break;
          case "portrait":
            // 9:16 aspect ratio
            aspect = 9 / 16;
            width = Math.min(width, height * aspect);
            height = Math.min(height, width / aspect);
            break;
          case "square":
            // 1:1 aspect ratio.
            aspect = 1 / 1;
            width = Math.min(width, height * aspect);
            height = Math.min(height, width / aspect);
            break;
        }
        return { height: height, width: width };
      },
      copyFontSettings() {
        this.template.fontFaceAuthor = this.template.fontFaceQuote;
        this.template.fontColorAuthor = this.template.fontColorQuote;
        this.setAuthorJustification(this.getJustificationName(this.template.textAlignQuote));
      },
      closeSidebars() {
        this.closeFontSidebar();
        this.closeImageSearchSidebar();
      },
      openImageSearchSidebar() {
        this.closeSidebars();
        this.showImageSearchSidebar = true;
        this.listenForImageScroll();
      },
      closeImageSearchSidebar() {
        this.showImageSearchSidebar = false;
        this.unlistenForImageScroll();
      },
      openFontSidebar(fontType) {
        this.closeSidebars();
        this.showFontSidebar = true;
        this.sidebarFontType = fontType;
      },
      closeFontSidebar(fontType) {
        this.showFontSidebar = false;
      },
      selectFont(font) {

        // Check if the user is eligible to use this font
        if (font.isPro && !this.self.isPro) {
          this.$bvModal.show("modal-get-quozio-pro-fonts");
          this.$ga.event("GetQuozioPro", "Get Quozio Pro - Custom Template Font Modal", font.name);
          return;
        }

        if (this.sidebarFontType == "author" || this.fontSameAsQuote) {
          this.setAuthorFont(font);
        }
        if (this.sidebarFontType == "quote") {
          this.setQuoteFont(font);
        }
      },
      resetTemplate() {
        this.clearCurrentState();
        this.$router.go();
      },
      getCurrentStakeKey() {
        // If a model change breaks loading old templates from local storage, you can change the version, as needed.
        return "currentState-v1-" + (this.$route.params.templateId || "new");
      },
      saveCurrentState() {
        // If we have it disabled for debugging, don't load it.
        let disableState = localStorage.getItem("disableState");
        if (disableState) {
          return;
        }
        let key = this.getCurrentStakeKey();
        let canvas = document.querySelector(`.${canvasClass}`);
        let state = {
          lastModified: new Date(),
          template: this.template,
          canvasImageUrl: this.canvasImageUrl,
          fontSameAsQuote: this.fontSameAsQuote,
          savedFixedTextPositions: this.savedFixedTextPositions,
          savedFilterSettings: this.savedFilterSettings,
          recentImages: this.recentImages,
          removeWatermark: this.removeWatermark,
          removeQuoteBackground: this.removeQuoteBackground,
          clientWidth: canvas.offsetWidth,
          clientHeight: canvas.offsetHeight,
        }
        localStorage.setItem(key, JSON.stringify(state));
      },
      loadCurrentState() {
        // If we have it disabled for debugging, don't load it.
        let disableState = localStorage.getItem("disableState");
        if (disableState) {
          return;
        }
        // First, load all local storage and remove any that haven't been touched in 3 days.
        for (const key in localStorage) {
          if (localStorage.hasOwnProperty(key)) {
            const value = localStorage.getItem(key);
            try {
              let state = JSON.parse(value);
              let lastModified = new Date(state.lastModified);
              // 2 hours. This could be extended, but it's not really intended for long-term storage but rather protection against accidental browser reloads.
              // Sometimes, especially mobile browsers, will reload when you put them out of focus, not even very long.
              let expiration = lastModified.setHours(lastModified.getHours() + 2);
              if (expiration < new Date()) {
                localStorage.removeItem(key);
                console.warn("A local storage item has expired. Removing from cache.");
              }
            } catch (e) {
              // Likely corrupted. Remove it.
              console.warn("A local storage item is invalid. Removing from cache.");
              localStorage.removeItem(key);
            }
          }
        }
        let key = this.getCurrentStakeKey();
        let stateJson = localStorage.getItem(key);
        if (!stateJson) {
          return;
        }
        let state;
        try {
          state = JSON.parse(stateJson);
        } catch (e) {
          console.warn("A local storage item is invalid. Removing from cache.");
          clearCurrentState();
          return;
        }
        this.template = state.template;
        this.canvasImageUrl = state.canvasImageUrl;
        this.fontSameAsQuote = state.fontSameAsQuote;
        this.savedFixedTextPositions = state.savedFixedTextPositions;
        this.savedFilterSettings = state.savedFilterSettings;
        this.recentImages = state.recentImages;
        this.removeWatermark = state.removeWatermark;
        this.removeQuoteBackground = state.removeQuoteBackground;
      },
      clearCurrentState() {
        let key = this.getCurrentStakeKey();
        localStorage.removeItem(key);
      },
      async search(query) {
        // If there's nothing in the box, use a random value from the ideas list.
        if (!query) {
          let randomIndex = Math.floor(Math.random() * this.searchIdeas.length);
          query = this.searchIdeas[randomIndex];
          this.query = query;
        }
        if (query) {
          this.searchResults = { data: [], pageNext: null };
          this.openImageSearchSidebar();
          this.imageSearchMessage = null;
          return await this.executeSearch(query);
        }
      },
      async searchPage(pageNext) {
        return await this.executeSearch(null, pageNext);
      },
      async executeSearch(query, page) {
        let params = page ? { page: page } : { query: query };
        let response = await this.$dataService.post(`/search/images`, null, params);
        if (response.error) {
          this.error = response.error;
          window.scrollTo(0, 0);
          return;
        }
        this.searchResults.pageNext = response.data.pageNext;
        this.searchResults.data = this.searchResults.data.concat(response.data.data);
        this.imageSearchMessage = this.searchResults.data.length == 0 ? `No images found for '${this.query}'` : null;
      },
      async deleteItem() {
        this.submitting.deleteItem = true;
        this.$nuxt.$loading.start();
        let response = await this.$dataService.delete(`/userTemplates/${this.template.userTemplateId}`);
        this.submitting.deleteItem = false;
        if (response.error) {
          this.error = response.error;
          this.$nuxt.$loading.finish();
          return;
        }

        this.$nuxt.$loading.finish();
        let toast = this.$toasted.show("The design has been deleted", {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
          iconPack: "fontawesome",
          icon: "thumbs-up",
          type: "success",
          keepOnHover: false
        });
        this.$router.push({ name: "user-designs" });
      },
      getRoutePath() {
        var path = this.$route.path;
        if (this.$route.query?.quoteId) {
          path += "?quoteId=" + this.$route.query.quoteId;
        }
        return path;
      },
      async saveAs() {

        // Check if the user is eligible to use this template
        if (!this.self.userId) {
          this.$bvModal.show("modal-create-account-save-design");
          this.$ga.event("UserTemplate", "Create Account - Save User Template", 0);
          return;
        }

        if (this.add) {
          await this.saveTemplate(true);
        } else {
          this.$bvModal.show("save-as");
        }
      },
      async saveTemplate(asNew) {

        this.error = null;
        this.saving = true;
        window.scrollTo(0, 0);
        var templateCopy = JSON.parse(JSON.stringify(this.template));
        if (!this.quote) {
          this.saving = false;
          this.error = { message: "You must provide a quote. Open the 'Quote' section and provide the text for the quote you wish to use." };
          return;
        }

        // Set the client canvas size
        let canvas = document.querySelector(`.${canvasClass}`);
        templateCopy.clientCanvasWidth = canvas.offsetWidth;
        templateCopy.clientCanvasHeight = canvas.offsetHeight;

        // Convert from decimal to integer.
        templateCopy.backgroundRadiusQuote = Math.round(this.template.backgroundRadiusQuote);

        // If the quote background is off or invisible, remove it.
        if (this.removeQuoteBackground || !templateCopy.backgroundAlphaQuote) {
          delete templateCopy.backgroundColorQuote;
          delete templateCopy.backgroundAlphaQuote;
          delete templateCopy.backgroundRadiusQuote;
        }

        // If the watermark background is off, remove it.
        if (this.removeWatermark) {
          delete templateCopy.watermarkColor;
          delete templateCopy.watermarkBackgroundColor;
          delete templateCopy.watermarkBackgroundHeight;
          delete templateCopy.watermarkAlpha;
        }

        // Prevent the range input from becoming a string.
        templateCopy.watermarkAlpha = templateCopy.watermarkAlpha ? parseInt(templateCopy.watermarkAlpha) : 0;
        templateCopy.filterAlpha = templateCopy.filterAlpha ? parseInt(templateCopy.filterAlpha) : 0;
        templateCopy.backgroundAlphaQuote = templateCopy.backgroundAlphaQuote ? parseInt(templateCopy.backgroundAlphaQuote) : 0;

        // Set the line height, based on the font. In the future, you might allow the user to set this.
        templateCopy.fontLineSpacingQuote = this.getFontLineSpacing(templateCopy.fontFaceAuthor);

        // Provide the quote and author so it can be used in the preview image
        templateCopy.quote = this.quote;
        templateCopy.author = this.author;

        // If this is marked as "asPersonal", then make active true.
        // This is when an admin is creating a template, but they intend it to be associated with their own account rather than a public "quozio" template
        if (!templateCopy.asPersonal) {
          // Make sure it's not null
          delete templateCopy.asPersonal;
        }
        if (templateCopy.asPersonal) {
          templateCopy.active = true;
        }

        this.$nuxt.$loading.start();
        let response;
        if (asNew) {
          response = await this.$dataService.post(`/userTemplates`, templateCopy);
        } else {
          response = await this.$dataService.put(`/userTemplates/${templateCopy.userTemplateId}`, templateCopy);
        }

        if (response.error) {
          this.error = response.error;
          this.$nuxt.$loading.finish();
          this.saving = false;
          this.$bvModal.hide("save-as");
          return;
        }
        let userTemplate = response.data;

        if (asNew) {
          this.$ga.event("UserTemplate", "Create User Template", this.self.isPro);
        } else {
          this.$ga.event("UserTemplate", "Update User Template", this.self.isPro);
        }

        // Create the quote from the text
        let quoteResponse = await this.$dataService.post(`/quotes`, { quote: this.quote, author: this.author });
        if (quoteResponse.error) {
          this.$nuxt.$loading.finish();
          this.error = quoteResponse.error;
          this.saving = false;
          return;
        }
        let quote = quoteResponse.data;

        // Get the imageUrls, so you can get the page key
        let imageUrlsResponse = await this.$dataService.get(`/quotes/${quote.quoteId}/imageUrls?`, { templateId: userTemplate.userTemplateId });
        if (imageUrlsResponse.error) {
          this.$nuxt.$loading.finish();
          this.error = imageUrlsResponse.error;
          this.saving = false;
          return;
        }

        let imageUrls = imageUrlsResponse.data;
        this.$nuxt.$loading.finish();
        this.saving = false;

        // Clear the current state since it's now saved server side.
        this.clearCurrentState();

        // What I'm doing here is setting some data that will be available to the quote view page after the redirect.
        // The quote view page will use it to know where the user has come from so it can take particular actions, compared to a user that lands on the quote view page normally (i.e. without having just edited its design)
        // After the quote view page reads this data from the state, it will clear it. Normally I would pass something like this via a query string, but I don't want to track state via the query string because the URL is shareable and I don't want to pollute it with situational metadata.
        this.setDesign({ templateId: userTemplate.userTemplateId, isNew: asNew });

        // Replace the current page in the browser history with the page that will edit this template and quote.
        // This helps when they start on the "/new" page and also when they modify the quote, so they don't click back and end up at the default page.
        window.history.replaceState(null, null, `/design/${userTemplate.userTemplateId}/edit?quoteId=${quote.quoteId}`);
        this.$router.push({ name: 'quote-quoteId-templateId-quoteSlug', params: { quoteId: quote.quoteId, templateId: `${userTemplate.userTemplateId}-${imageUrls.key}`, quoteSlug: quote.slug } });
      },
      goBack() {
        this.$router.go(-1);
      },
      // Event listeners
      // Image Scroll
      listenForImageScroll() {
        let imageSearchScroll = document.querySelector(".image-search-scroll");
        imageSearchScroll.addEventListener("scroll", this.onImageScroll);
      },
      unlistenForImageScroll() {
        let imageSearchScroll = document.querySelector(".image-search-scroll");
        imageSearchScroll.removeEventListener("scroll", this.onImageScroll);
      },
      async onImageScroll(event) {
        let imageSearchScroll = event.target;
        let margin = 400; // How far from the bottom before you trigger the next page?
        let reload = imageSearchScroll.scrollHeight - Math.round(imageSearchScroll.scrollTop) - margin <= imageSearchScroll.clientHeight;
        if (reload && this.searchResults.pageNext && this.backgroundLoadReady) {
          this.backgroundLoadReady = false;
          await this.searchPage(this.searchResults.pageNext);
          this.backgroundLoadReady = true;
        }
      },
      // Quote Color Picker Listener
      listenForQuoteColorPickerInput() {
        let picker = document.querySelector(".quote-color-picker");
        picker.addEventListener("input", this.onQuoteColorPickerInput);
      },
      unlistenForQuoteColorPickerInput() {
        let picker = document.querySelector(".quote-color-picker");
        picker.removeEventListener("input", this.onQuoteColorPickerInput);
      },
      onQuoteColorPickerInput(event) {
        if (this.quoteColorPickerTimeout)
          clearTimeout(this.quoteColorPickerTimeout);
        this.quoteColorPickerTimeout = setTimeout(() => {
          this.template.fontColorQuote = event.target.value;
          if (this.fontSameAsQuote) {
            this.template.fontColorAuthor = event.target.value;
          }
        }, colorPickerDelay)
      },
      // Quote Background Color Picker Listener
      listenForQuoteBackgroundColorPickerInput() {
        let picker = document.querySelector(".quote-background-color-picker");
        picker.addEventListener("input", this.onQuoteBackgroundColorPickerInput);
      },
      unlistenForQuoteBackgroundColorPickerInput() {
        let picker = document.querySelector(".quote-background-color-picker");
        picker.removeEventListener("input", this.onQuoteBackgroundColorPickerInput);
      },
      onQuoteBackgroundColorPickerInput(event) {
        if (this.quoteBackgroundColorPickerTimeout)
          clearTimeout(this.quoteBackgroundColorPickerTimeout);
        this.quoteBackgroundColorPickerTimeout = setTimeout(() => {
          this.template.backgroundColorQuote = event.target.value;
          this.setQuoteBackgroundCss(this.removeQuoteBackground, false);
        }, colorPickerDelay)
      },
      // Author Color Picker Listener
      listenForAuthorColorPickerInput() {
        let picker = document.querySelector(".author-color-picker");
        picker.addEventListener("input", this.onAuthorColorPickerInput);
      },
      unlistenForAuthorColorPickerInput() {
        let picker = document.querySelector(".author-color-picker");
        picker.removeEventListener("input", this.onAuthorColorPickerInput);
      },
      onAuthorColorPickerInput(event) {
        if (this.authorColorPickerTimeout)
          clearTimeout(this.authorColorPickerTimeout);
        this.authorColorPickerTimeout = setTimeout(() => {
          this.template.fontColorAuthor = event.target.value;
          this.setWatermarkCss(this.removeWatermark, false);
        }, colorPickerDelay)
      },
      // Watermark Color Picker Listener
      listenForWatermarkColorPickerInput() {
        let picker = document.querySelector(".watermark-color-picker");
        picker.addEventListener("input", this.onWatermarkColorPickerInput);
      },
      unlistenForWatermarkColorPickerInput() {
        let picker = document.querySelector(".watermark-color-picker");
        picker.removeEventListener("input", this.onWatermarkColorPickerInput);
      },
      onWatermarkColorPickerInput(event) {
        if (this.watermarkColorPickerTimeout)
          clearTimeout(this.watermarkColorPickerTimeout);
        this.watermarkColorPickerTimeout = setTimeout(() => {
          this.template.watermarkColor = event.target.value;
        }, colorPickerDelay)
      },
      // Watermark Background Color Picker Listener
      listenForWatermarkBackgroundColorPickerInput() {
        let picker = document.querySelector(".watermark-background-color-picker");
        picker.addEventListener("input", this.onWatermarkBackgroundColorPickerInput);
      },
      unlistenForWatermarkBackgroundColorPickerInput() {
        let picker = document.querySelector(".watermark-background-color-picker");
        picker.removeEventListener("input", this.onWatermarkBackgroundColorPickerInput);
      },
      onWatermarkBackgroundColorPickerInput(event) {
        if (this.watermarkBackgroundColorPicker)
          clearTimeout(this.watermarkBackgroundColorPicker);
        this.watermarkBackgroundColorPicker = setTimeout(() => {
          this.template.watermarkBackgroundColor = event.target.value;
        }, colorPickerDelay)
      },
      // Click Off Canvas Listener
      listenForClickOffCanvas() {
        document.addEventListener("click", this.onClickOffCanvas);
        document.addEventListener("touchstart", this.onClickOffCanvas);
      },
      unlistenForClickOffCanvas() {
        document.removeEventListener("click", this.onClickOffCanvas);
        document.removeEventListener("touchstart", this.onClickOffCanvas);
      },
      onClickOffCanvas(event) {
        let quotebox = document.querySelector(`.${quoteboxClass}`);
        let authorbox = document.querySelector(`.${authorboxClass}`);
        let watermarkbox = document.querySelector(`.${watermarkboxClass}`);
        const withinBoundaries = event.composedPath().includes(quotebox) || event.composedPath().includes(authorbox) || event.composedPath().includes(watermarkbox)
        if (withinBoundaries) {
          this.showGuides(this.quoteMoveable, quoteboxClass);
          this.showGuides(this.authorMoveable, authorboxClass);
          this.showGuides(this.watermarkMoveable, watermarkboxClass);
        } else {
          this.hideGuides(this.quoteMoveable, quoteboxClass);
          this.hideGuides(this.authorMoveable, authorboxClass);
          this.hideGuides(this.watermarkMoveable, watermarkboxClass);
        }
      },
      ...mapActions({ setDesign: "design/set" }),
    },
    computed: {
      ...mapState("self", { self: "self" }),
      ...mapState("design", { design: "design" }),
    },
  };
</script>
